import { Form, Select, Typography } from 'antd';
import { useStoreState } from '../../store';
import type { FormInstance } from 'antd/lib/form';

import type { PartnerPackagingV2 } from '../../store/services/PartnerService/types';
import type { ModalParams } from '../../store/navigation/types';
const { Paragraph } = Typography;

export interface PackagingSetFormProps {
  form: FormInstance;
  activePartnerPackagingSet?: ModalParams;
}

export const EditPackagingSetForm = ({ form, activePartnerPackagingSet }: PackagingSetFormProps) => {
  const partnerPackaging = useStoreState((state) => state.packagingV2.partnerPackagingV2);

  form.setFieldsValue({
    packagingIds: activePartnerPackagingSet?.packagingIds,
  });

  return (
    <Form form={form} layout={'vertical'} wrapperCol={{ span: 20, offset: 1 }}>
      {activePartnerPackagingSet && (
        <Form.Item label={<b>Packaging ID</b>} style={{ marginBottom: 10 }} name="packagingId">
          <Paragraph copyable>{activePartnerPackagingSet?.packagingSetId}</Paragraph>
        </Form.Item>
      )}

      {partnerPackaging && (
        <Form.Item name={'packagingIds'} label={<b>Select Packaging Options</b>}>
          <Select mode="multiple">
            {partnerPackaging
              .filter((p) => p.active === true)
              .map((p: PartnerPackagingV2) => (
                <Select.Option key={p.packagingId} value={p.packagingId}>
                  {String(p?.name)}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>
      )}
    </Form>
  );
};
